<template>
  <v-dialog
    v-model="isShowDialog"
    :value="showDialog"
    :width="width"
    :fullscreen="fullscreen"
    persistent
    :scrollable="scrollable"
  >
    <slot name="body" />
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    'show-dialog': {
      type: Boolean,
      required: true,
    },
    width: {
      default: 500,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapState('authModule', ['tokenInvalid']),
    isShowDialog: {
      get() {
        return this.tokenInvalid ? false : this.showDialog
      },
      set() {
        this.showDialog = this.value
      },
    },
  },
}
</script>

<style></style>
